module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-wallet-uninvoiced"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Client")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.client.id
        }
      }
    }
  }, [_vm._v("CL" + _vm._s(_vm.item.client.id) + " " + _vm._s(_vm.item.client.name) + " " + _vm._s(_vm.item.client.surname))])], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Uninvoiced Records")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.records.length))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Amount")]), _c('div', {
    staticClass: "field-value",
    class: {
      'warning-text': _vm.item.billable_amount < 0
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.billable_amount)))])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button fa fa-2x",
    class: {
      'fa-arrow-up': _vm.detail, 'fa-arrow-down': !_vm.detail
    },
    on: {
      "click": function($event) {
        _vm.detail = !_vm.detail
      }
    }
  })])])]), (_vm.detail) ? [_c('table', [_vm._m(0), _c('tbody', _vm._l((_vm.item.records), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _c('td', [_vm._v(_vm._s(item.driver_id))]), _c('td', [_c('div', [_vm._v(_vm._s(_vm._f("walletableType")(item.walletable_type)))]), _c('div', [_vm._v(_vm._s(item.walletable_id))])]), _c('td', {
      staticStyle: {
        "font-family": "monospace"
      }
    }, _vm._l((item.reason.split('|')), function(reason) {
      return _c('div', [(reason.startsWith('---')) ? _c('hr', {
        staticStyle: {
          "border-style": "dotted",
          "margin": "0.5em"
        }
      }) : (reason.startsWith('- ')) ? _c('strong', [_vm._v(_vm._s(_vm.cleanString(reason, "- ")))]) : (reason.startsWith('>>')) ? _c('span', {
        staticStyle: {
          "display": "block",
          "text-indent": "1em"
        }
      }, [_vm._v(_vm._s(_vm.cleanString(reason, ">>")))]) : _c('span', [_vm._v(_vm._s(reason))])])
    }), 0), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(item.amount, item.tax).toFixed(2))))])]), _c('div', [_c('small', [_vm._v(_vm._s(-item.tax * 100) + "%")])])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(-item.amount, -item.tax).toFixed(2))))]), _c('div', [_c('small', [_vm._v(_vm._s(_vm.$priceWithcurrency(-item.amount)) + " VAT EXC")])])])])
  }), 0)]), _c('ActionButton', {
    attrs: {
      "action": _vm.billWallet,
      "confirm": "confirm"
    }
  }, [_vm._v("Bill wallet")])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Driver Id")]), _c('th', [_vm._v("Type & Id")]), _c('th', [_vm._v("Description (Reason)")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Tax")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Amount")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d1ecc080!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/WalletUninvoiced.vue
// module id = 2491
// module chunks = 1